import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { getCheckoutUrl } from '../utils/utm';

export const GuaranteeSection = () => {
  const checkoutUrl = getCheckoutUrl();

  return (
    <section 
      data-testid="guarantee-section"
      className="section-padding px-8 md:px-12 bg-white"
    >
      <div className="max-w-4xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Guarantee Visual */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="flex justify-center"
          >
            <div className="relative">
              {/* Outer ring */}
              <div className="w-64 h-64 rounded-full border-2 border-amber-200 flex items-center justify-center">
                {/* Inner circle */}
                <div className="w-48 h-48 rounded-full bg-gradient-to-br from-amber-50 to-amber-100 border-2 border-amber-600 flex flex-col items-center justify-center text-center px-4">
                  <ShieldCheck className="w-10 h-10 text-amber-600 mb-2" />
                  <span className="font-editorial text-lg font-bold text-gray-900 leading-tight">Member</span>
                  <span className="font-editorial text-lg font-bold text-gray-900 leading-tight">Protection</span>
                  <span className="font-sans text-xs text-gray-500 mt-1 uppercase tracking-wider">Guarantee</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-[2px] bg-amber-600" />
              <p className="font-sans text-xs tracking-widest uppercase text-gray-400">
                Our Commitment
              </p>
            </div>
            
            <h2 className="font-editorial text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-8">
              Try the Full Program. If It Is Not Right for You,{' '}
              <span className="text-amber-600">We Give You Your $7 Back.</span>
            </h2>

            <div className="font-sans text-lg text-gray-600 leading-relaxed space-y-5">
              <p>
                Join for $7. Work through the orientation video. Attend a Trade Lab session. Go through the foundation lessons at whatever pace works for you. If you decide Payne's Education is not what you were looking for, contact us and request your $7 back with no argument, no guilt, and no complicated cancellation process. You keep the Tax Strategies for Investors training either way.
              </p>
            </div>

            {/* CTA */}
            <div className="mt-8">
              <a
                href={checkoutUrl}
                data-testid="guarantee-cta-button"
                className="btn-primary inline-block"
              >
                Start My 30-Day Trial for $7
              </a>
              <p className="font-sans text-sm text-gray-500 mt-3">
                100% satisfaction guarantee. Cancel anytime.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
